

import { CloseOutlined } from '@ant-design/icons'
import {
  Button,
  Flex,
  Menu,
} from 'antd'
import classNames from 'classnames'
import React, {
  createElement,
  ReactNode,
  useCallback,
} from 'react'

import PageHeader from '@/components/shared/page-header'
import { FeatureKey } from '@/constants/feature-key'
import { setFeatureKeys } from '@/redux/global'
import { selectMenuItems } from '@/redux/menu-selector'
import {
  createAppSelector,
  useAppDispatch,
  useAppSelector,
} from '@/redux/utils'
import { MenuItem } from '@/utils/menu'

import RoleSettings from './role-settings/role-settings'
import SalesSettings from './sales-settings/sales-settings'
import s from './settings.module.css'

const sideBarMenuItemConfig: Record<string, () => ReactNode> = {
  [FeatureKey.SalesSettings]: SalesSettings,
  [FeatureKey.RoleSettings]: RoleSettings,
}

const selector = createAppSelector([
  selectMenuItems,
  ({ global }) => global.featureKeys,
], (menuItems, featureKeys) => {
  const defaultMenuItems = [
    // createMenuItem(FeatureKey.YourAccount, 'Your Account'),
    // createMenuItem(FeatureKey.YourPreferences, 'Your Preferences'),
  ] as MenuItem[]
  const settingsMenuItems = menuItems.find(m => m.key === FeatureKey.Settings.toString())?.children || []
  const mergedMenuItems = [...defaultMenuItems, ...settingsMenuItems]
  const selectedMenuItem = mergedMenuItems
    .find(m => m.key === featureKeys.at(-1)?.toString()) || mergedMenuItems[0]

  return { menuItems: mergedMenuItems, selectedMenuItem }
})

export default function SettingsPage() {
  const dispatch = useAppDispatch()
  const { menuItems, selectedMenuItem } = useAppSelector(selector)

  const handleSelect = useCallback(({ key }: { key: string }) => {
    dispatch(setFeatureKeys([FeatureKey.Settings, key as FeatureKey]))
  }, [dispatch])

  const handleCloseSettings = useCallback(() => {
    dispatch(setFeatureKeys([FeatureKey.Home]))
  }, [dispatch])

  return (
    <Flex className={s.settingsPage}>
      <PageHeader
        leftSection="Settings"
        rightSection={
          <Button
            type="text"
            size="small"
            icon={<CloseOutlined />}
            onClick={handleCloseSettings}
          />
        }
      />
      <Flex className={s.pageContent}>
        <Flex className={s.sideBar}>
          <Menu
            className={classNames('settings-menu', s.menu)}
            mode="vertical"
            items={menuItems}
            selectedKeys={[selectedMenuItem.key]}
            onSelect={handleSelect}
          />
        </Flex>
        <Flex vertical className={s.content}>
          {createElement(sideBarMenuItemConfig[selectedMenuItem.key])}
        </Flex>
      </Flex>
    </Flex>
  )
}
